import { alpha, Box, styled } from "@mui/material";

const StyledGlassPanel = styled(Box)(({theme})=>({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.25),
    padding: theme.spacing(0.75),
    borderRadius: theme.spacing(2),
    backdropFilter: "blur(12px)",
    WebkitBackdropFilter: "blur(12px)",
    backgroundColor: alpha((theme as any).palette.neutral.darkest, 0.4),
    border: `1px solid ${alpha(theme.palette.common.white, 0.12)}`,
    boxShadow: `0 4px 16px ${alpha((theme as any).palette.neutral.darkest, 0.3)}`,
}))

export { StyledGlassPanel }
